(function() {

  'use strict';

  angular.module('eclipseApp.myAccount').controller('printInvoiceCtrl', ['$scope', '$http', 'uteEndpoint', 'data', '$window', function($scope, $http, uteEndpoint, data, $window) {
    var accountNumber = data.accountNumber;
    var documentId = data.documentId;
    var token = '';
    var printURL = '';
    $scope.init = function(){
      $scope.screen = 'loading';
      var config = {
        cmsBase: '/bbapp/bbcms'
        , fromReceiveDate: '2013-10-10'
        , appID: 'Fido.ca'
        , timeoutUserSummary: '5000'
        , timeoutDocuments: '10000'
      };
      BBAPI.setConfig(config);
        $http({
          method: 'POST',
          url: uteEndpoint('olb/retrieveBBToken'),
          data: {
              accountNumber: accountNumber
          }
        }).success(function(tokenNumber){
          token = tokenNumber.token;
          var config = {
              EncryptedToken: token
          };
          BBAPI.setConfig(config);
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function() {
              if(xhr.readyState == 4 && xhr.status == 200) {
                 $scope.screen = 'successPrintPDF';
                 printURL = "rogers_rest/rogers/" + documentId + ".pdf?download=false&EncryptedToken=" + encodeURIComponent(token);
                 var pdfViewerEmbed = document.getElementById("pdfDocument");
                 pdfViewerEmbed.setAttribute("src", printURL);
                 setTimeout(function () {
                     $window.frames["printf"].focus();
                     $window.frames["printf"].print();
                 }, 5000);
              }
              else if (xhr.status == 500 || xhr.status == 404) {
                $scope.screen = 'errorInPrintPDF';
              }
          }
          xhr.open('head',"rogers_rest/rogers/" + documentId + ".pdf?download=false&EncryptedToken=" + encodeURIComponent(token));
          xhr.send(null);
          //printURL = "rogers_rest/rogers/" + documentId + ".pdf?download=false&EncryptedToken=" + encodeURIComponent(token);
         // var pdfViewerEmbed = document.getElementById("pdfDocument");
         // pdfViewerEmbed.setAttribute("src", printURL);

      });
    }
    $scope.init();
  }]);

})();
